import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function UpdateClassified() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        classified: '',
        isActive: false,
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchClassified = async () => {
            try {
                const res = await axios.get(`https://backend-zkgn.onrender.com/api/classified/${id}`);
                setFormData({
                    classified: res.data.classified_name,
                    isActive: res.data.isActive === 1
                });
                setLoading(false);
            } catch (err) {
                console.error('Error fetching classified:', err.message);
                setLoading(false);
            }
        };

        fetchClassified();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const validate = () => {
        const tempErrors = {};
        let isValid = true;

        if (!formData.classified.trim()) {
            tempErrors.classified = 'Please enter a classified name.';
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await axios.put(`https://backend-zkgn.onrender.com/api/classified/${id}`, {
                classified_name: formData.classified,
                isActive: formData.isActive ? 1 : 0
            });

            setSuccessMessage('Classified updated successfully!');
            setTimeout(() => {
                setSuccessMessage('');
                navigate('/classifieds');
            }, 2000);
        } catch (err) {
            console.error('Update error:', err.message);
        }
    };

    if (loading) return <div className="text-center my-5">Loading...</div>;

    return (
        <div className="container my-5">
            <h2 className="mb-4 text-center">Edit Classified</h2>

            {successMessage && (
                <div className="alert alert-success text-center" role="alert">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="mb-3">
                    <label className="form-label">Classified Name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="classified"
                        value={formData.classified}
                        onChange={handleChange}
                    />
                    {errors.classified && <small className="text-danger">{errors.classified}</small>}
                </div>

                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="isActive"
                        checked={formData.isActive}
                        onChange={handleChange}
                        id="isActiveCheck"
                    />
                    <label className="form-check-label" htmlFor="isActiveCheck">
                        Active
                    </label>
                </div>

                <div className="text-center">
                    <button type="submit" className="btn btn-success px-4">Update Classified</button>
                </div>
            </form>
        </div>
    );
}

export default UpdateClassified;
